export enum AuthApiConstant {
  VALIDATE_CAPTCHA = '/auth/captcha/validate',
  VERIFY_TOKEN = '/auth/token/verify',
  VERIFY_SECURITY_ANSWER = '/auth/recovery/answer',
  ACTIVATE_USER = '/auth/setup/useraccount',
  FORGOT_AUTH = '/auth/password/forgot/email',
  RESET_AUTH = '/auth/password/reset',
  GET_SECURITY_QUESTIONS = '/auth/recovery/questions',
  CHANGE_AUTH = '/auth/password/change',
  UPDATE_SECURITY_QUESTION = '/auth/recovery/question/change',
  UNLOCK_ACCOUNT = '/auth/unlock/email',
  REGISTER_USER = '/auth/user/register',
  GET_VERIFY_TOKEN = '/login/migrateduser/recoverytoken',
  OKTA_SESSION_CREATE = '/auth/session/create',
  OKTA_SESSION_VALIDATE = '/auth/session/validate',
  OKTA_SESSION_CLEAR = '/auth/session/clear',
  REGISTER_MIGRATE_USER = '/auth/migratuser/register',
  CHECK_DUPLICATE_EMAIL = '/auth/user/duplicateemail'
}

export enum ConfigApiConstant {
  VALIDATE_NDC = '/setting/ndc/',
  GET_PRODUCTS = '/config/product',
  SEARCH_PRODUCTS = '/config/product/search',
  BARCODE_SEARCH = '/config/product/barcode/search',
  GET_PRODUCTS_INV_PRICE = '/config/product/realtimedata',
  VALIDATE_PRODUCT = '/config/product/validate',
  GET_PRODUCT_TYPEFORWARD = '/config/product/typeForward/',
  GET_CHAT = '/setting/chat',
  GET_STATIC_DATA = '/setting/data/static',
  GET_GLOBAL_CHAT_SETTINGS = '/setting/globalsetting/details ',
  AUTHENTICATE = '/config/login/authenticate/parmedweb',
  CONTACT_US = '/setting/email/contactus',
  GET_CREDIT_CARDS = '/config/creditcard/details',
  ADD_CREDIT_CARD = '/config/creditcard/add',
  UPDATE_CREDIT_CARD = '/config/creditcard/update',
  DELETE_CREDIT_CARD = '/config/creditcard/delete',
  GET_SIGNED_DATA = '/config/paymetric/signData',
  GET_ACCESS_TOKEN = '/config/paymetric/accessToken',
  GET_PAYPAL_TOKEN_DETAILS = '/config/paypal/token',
  GET_RESPONSE_PACKET = '/config/paymetric/responseToken',
  GET_PRODUCT_IMAGES = '/config/product/image',
  GET_PRODUCT_DETAILS = '/config/product/details',
  GET_PRODUCT_PURCHASE_HISTORY = '/config/product/purchasehistory',
  GET_PRODUCT_SUBSTITUTES = '/config/product/substitute',
  GET_PRODUCT_HISTORY = '/config/product/history',
  GET_SERVER_DATETIME = '/setting/currentdatetime',
  GET_PRODUCT_CATALOG = '/config/catalog',
  GET_PRODUCTS_BY_CATALOG_ID = '/config/catalog/products',
  GET_FAVORITES = '/config/favlist/fetch',
  GET_FAVORITE_PRODUCTS = '/config/favlist/view',
  CREATE_FAVORITE_LIST = '/config/favlist',
  ADD_PRODUCT_TO_FAVORITE_LIST = '/config/favlist/item',
  DELETE_FAVORITE_LIST = '/config/favlist/delete',
  DELETE_PRODUCT_FROM_FAVORITE_LIST = '/config/favlist/item/delete',
  RENAME_FAVORITE_LIST = '/config/favlist/rename',
  MOVE_FAVORITE_PRODUCT = '/config/favlist/item/move',
  ADD_PRODUCT_TO_WATCH_LIST = '/config/watchlist/item',
  DELETE_PRODUCT_FROM_WATCH_LIST = '/config/watchlist/delete',
  GET_WATCHLIST_PRODUCTS = '/config/watchlist/view',
  GET_CONFIG_PROPERTIES = '/setting/',
  GET_SERVER_METAINFO = '/setting/metainfo',
  GET_PROMOTION = '/config/category/fetch',
  GET_CATEGORY_ITEM = '/config/category/items/details',
  GET_SUBSCRIPTION = '/config/category/fetch',
  GET_SUBSCRIPTION_ITEMS = '/config/category/items/details',
  GET_ITEMS_ON_SALE_FROM_PRODUCT_HISTORY = '/config/sale/product/history'
}

export enum LoginApiConstant {
  AUTHENTICATE_USER = '/authenticate/parmedweb',
  IS_USER_MIGRATE = '/migrateuser/userdetails',
  AUTHENTICATE_IDM_USER = '/authenticate/idm',
  GET_RECOVERY_TOKEN = '/migrateduser/recoverytoken',
  ACTIVATE_NON_MIGRATED_USER = '/migrateduser/activate'
}

export enum OrderApiConstant {
  GET_ORDERS = '/order/open',
  GET_ORDER_COUNT = '/order/cart/itemcount',
  ADD_TO_CART = '/order/cart/add',
  VIEW_CART = '/order/cart/details',
  VIEW_ORDER = '/order/details',
  UPDATE_ORDER = '/order/cart/update',
  GET_ORDER_HISTORY = '/order/history/configurable',
  GET_ORDER_HISTORY_DETAIL = '/order/history/details',
  GET_ORDER_HISTORY_FACTS_DETAIL = '/order/history/details_facts',
  GET_ORDER_TRACKING_DETAIL = '/order/track/fedex',
  GET_SUBMITTED_CSOS_ORDERS = '/order/csos',
  GET_CSOS_SUBMITTED_ORDER_DETAIL = '/order/csos/details',
  GET_CSOS_SUBMITTED_ORDER_DETAILS = '/order/csos/find',
  SAVE_CSOS_SUBMITTED_ORDER_DETAILS = '/order/csos/save',
  ORDER_SUMMARY = '/order/submit',
  GET_UNIQUE_TRACKING_NUMBER = '/order/utn',
  CHECK_OUT_ORDERS = '/order/checkout',
  CERT_PWD_ENCRYPT = '/order/certpassword/encrypt',
  SEARCH_TRACK_AND_TRACE = '/order/trackntrace',
  TRACK_AND_TRACE_DETAILS = '/order/trackntrace/details',
  RETURN_PRODUCT = '/order/return',
  PRODUCT_RETURN_SEARCH = '/order/return/search',
  GET_PREBOOK_PRODUCT = '/order/item/prebook',
  SUBMIT_PREBOOK_PRODUCT = '/order/item/prebook/submit',
  GET_INVOICE_DATA = '/order/cc/invoices',
  DOWNLOAD_INVOICE = '/order/download/invoice/',
  PAY_INVOICE = '/order/invoices/pay',
  DOWNLOAD_DSCSA = "/order/download/DSCSA",
  DOWNLOAD_DSCSA_BASE64 = "/order/download/DSCSA/base64",
  DOWNLOAD_INVOICE_BASE64 = '/order/download/invoice/base64/',
  MEDIA_UPLOAD_URL ='/order/media',
  UPDATE_REJECTED_ORDER = '/order/negotiated-order/reject',
  GET_ITEM_SERIALIZATION = '/order/return/isItemSerialized',
  CHECK_SERIAL_NUMBER = '/order/return/serialNumberCheck',
  GET_DSCSA_REPORTING ='/order/lookerReport'
}

export enum UserApiConstant {
  GET_ACCOUNTS = '/account/change',
  SAVE_ACCOUNT_SETTINGS = '/setting',
  LAST_REPINIT_CHAT_TIME = '/chat/repinittime/',
  DISABLE_PROMOTION_POPUP = '/promotion/disable'
}

export enum IdmApiConstant {
  SAVE_DEFAULT_ACCOUNT = '/idm/defaultaccount/save',
  USER_DETAIL = '/idm/login/detail',
  LOGOUT_USER = '/idm/logout'
}

export enum OktaApiConstant {
  USER_SESSION = '/api/v1/sessions/me'
}

export enum ChatApiConstant {
  START_CHAT = '/websvcs/chat/start',
  RECONNECT_CHAT = '/websvcs/chat/reconnect',
  POLL_CHAT = '/websvcs/chat/poll/',
  EXIT_CHAT = '/websvcs/chat/exit/',
  GET_PARTYINFO = '/websvcs/partyInfo/',
  QUEUE_QUERY = '/websvcs/queue/query',
  SEND_MESSAGE = '/websvcs/chat/sendMessage/',
  SET_TYPING_STATE = '/websvcs/chat/setTypingState/',
  CREATE_CALLBACK = '/websvcs/callback/create'
}


export enum ExpApiConstant {
  PRODUCT_SUGGESTION = 'query_suggestion?keyword=',
  GET_SUBSCRIPTION = 'category/fetch',
  GET_SUBSCRIPTION_ITEMS = 'category/items/details',
  PRODUCT_SEARCH = 'product',
  PRODUCT_SEARCH_LIST = 'productList',
  BARCODE_PRODUCT_SEARCH = 'product/barcode/search',
  SUBSCRIPTION_DETAILS = 'subscription/details',
  SAVE_SUBSCRIPTION = 'save/subscription',
  GET_SUBSCRIBED_ITEMS ='subscribed/items/details',
  SKIP_SUBSCRIPTION ='skip/subscription?subscriptionId=',
  DELETE_SUBSCRIBED_ITEMS = 'subscription/delete',
  EDIT_SUBSCRIPTION ='change/subscription/details',
  SEARCH_SUBSCRIPTION ='search/subscription/item',
  GET_SUBSTITUTION= 'product/substitute',
  GET_IMAGE_REF = 'item/images?fetchAll=',
  GET_CATEGORY_LIST = 'categoryList',
  GET_CATEGORY_DETAILS = 'get/categorylist/items/details'
}


export enum ProductApiConstant {

  PRODUCT_SUGGESTION = 'query_suggestion?keyword=',
  GET_SUBSCRIPTION = 'category/fetch',
  GET_SUBSCRIPTION_ITEMS = 'category/items/details',
  PRODUCT_SEARCH = 'product',
  PRODUCT_SEARCH_LIST = 'productList',
  BARCODE_PRODUCT_SEARCH = 'product/barcode/search',
  SUBSCRIPTION_DETAILS = 'subscription/details',
  SAVE_SUBSCRIPTION = 'save/subscription',
  GET_SUBSCRIBED_ITEMS = 'subscribed/items/details',
  SKIP_SUBSCRIPTION = 'skip/subscription?subscriptionId=',
  DELETE_SUBSCRIBED_ITEMS = 'subscription/delete',
  EDIT_SUBSCRIPTION = 'change/subscription/details',
  SEARCH_SUBSCRIPTION = 'search/subscription/item',
  GET_SUBSTITUTION = 'product/substitute',
  GET_IMAGE_REF = 'item/images?',
  GET_CATEGORY_LIST = 'categoryList',
  GET_CATEGORY_DETAILS = 'get/categorylist/items/details',
  GET_PRODUCT_SEARCH = 'search/productcatalog',
  FILTER_PRODUCT_CATALOG = 'productcatalog/filter?buid=',
  GET_PRODUCT_DETAILS_FOR_UNAUTH_USER = 'unauth-item/details',
  GET_PRODUCT_RECOMMANDATION = 'products-recommended'
 // GET_IMAGE_REF_UNAUTH = 'item/images'
}

export enum CmsApiConstant {
  CMS_CONTENT_TEMPLATE = '/cms/content/template',
  CMS_MEDIA = '/media/signed',
  CMS_CONTENT_CATEGORY = '/cms/content/category',
}
